import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-breadcrumb',
  templateUrl: './custom-breadcrumb.component.html',
  styleUrl: './custom-breadcrumb.component.scss'
})
export class CustomBreadcrumbComponent {
  @Input() listUrls : any 
}
